import NextNProgress from 'nextjs-progressbar'

export type PageProgressBarProps = {
  color: string
  height: number
  startPosition: number
  options?: Partial<{showSpinner: boolean}>
}

export default function PageProgressBar({
  color,
  height,
  startPosition,
  options,
}: PageProgressBarProps) {
  return (
    <NextNProgress
      color={color}
      height={height}
      startPosition={startPosition}
      options={options}
      stopDelayMs={200}
    />
  )
}
